<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            v-if="$route.name != `ProfilePage`"
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>
            {{
              $route.name == "ProfilePage" ? `My Profile` : `Edit User`
            }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.user_name"
                outlined
                label="User Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.user_name"
              ></v-text-field>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.referal_code"
                outlined
                label="Referal Code"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <label>Upload Pic</label>
              <template>
                <div class="image-upload">
                  <input type="file" @change="handleFileChange" />
                  <div v-if="imageUrl" class="preview">
                    <img :src="imageUrl" alt="Preview" />
                  </div>
                </div>
              </template>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.otp"
                outlined
                label="OTP"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.opening_balance"
                outlined
                label="Opening Balance"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.wallet"
                outlined
                label="Current Balance"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.given_points"
                outlined
                label="Given Point"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-autocomplete
                ref="gst"
                outlined
                v-model="form.gst_type"
                :items="gstItems"
                label="Gst Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.gst_type"
              ></v-autocomplete>
            </v-col>
            <v-col
              sm="4"
              v-if="
                form.position_id == 4 &&
                (form.gst_type == 2 || form.gst_type == 3)
              "
            >
              <v-text-field
                v-model="form.gst_certificate"
                outlined
                label="GST NO*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.gst_certificate"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-autocomplete
                ref="is_loan_approved"
                outlined
                v-model="form.is_loan_approved"
                :items="typeItems"
                label="Loan Approved Status*"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.is_loan_approved"
              ></v-autocomplete>
            </v-col>
            <v-col
              sm="4"
              v-if="form.position_id == 4 && form.is_loan_approved == 1"
            >
              <v-text-field
                v-model="form.loan_limit_amount"
                outlined
                disabled
                label="Loan Limit Amount"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-autocomplete
                ref="action_type"
                outlined
                v-model="form.action_type"
                :items="actionItems"
                label="Action Type"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.action_type"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4 && form.action_type != 0">
              <v-text-field
                v-model="form.set_limit"
                outlined
                label="Set Limit"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.set_limit"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4">
              <v-text-field
                v-model="form.balance_amount"
                outlined
                label="Balance Amount"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.address"
                outlined
                rows="4"
                label="Address*"
                prepend-inner-icon="mdi-map-marker-outline"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.reason"
                outlined
                rows="4"
                label="Reason"
                prepend-inner-icon="mdi mdi-account-off-outline"
              ></v-textarea>
            </v-col>
            <v-col sm="4" v-if="form.imei_no">
              <v-text-field
                :value="form.imei_no"
                outlined
                readonly
                label="Registered Device ID"
                prepend-inner-icon="mdi-cellphone-lock"
                hide-details
              >
                <template v-slot:append>
                  <v-btn
                    icon
                    small
                    color="error"
                    :loading="clearingImei"
                    @click="clearImei"
                    title="Clear device lock"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4 || form.position_id == 3">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_point"
                inset
                :label="`Is Point: ${form.is_point ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4" v-if="form.position_id == 4 || form.position_id == 3">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_gift"
                inset
                :label="`Is Gift: ${form.is_gift ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <template v-if="form.position_id == 2">
            <h2>Working Details</h2>
            <br />
            <v-row>
              <v-col sm="3">
                <v-text-field
                  v-model="form.state_location"
                  outlined
                  label="State"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.state_location"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="form.city"
                  outlined
                  label="City"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.city"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="form.area"
                  outlined
                  label="Allocate Area"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.area"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="form.pin_code"
                  outlined
                  label="Pin Code"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="errors.pin_code"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-autocomplete
                  ref="status"
                  outlined
                  v-model="form.status"
                  :items="statusItems"
                  label="Status"
                  prepend-inner-icon="mdi-arrow-expand-all"
                  clearable
                  :error-messages="errors.status"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </template>

          <template v-if="form.position_id == 5">
            <h2>Store Listings</h2>
            <br />
            <v-row>
              <v-col sm="4">
                <v-autocomplete
                  ref="store"
                  outlined
                  v-model="form.store_ids"
                  :items="storeItems"
                  label="Stores"
                  multiple
                  prepend-inner-icon="mdi-account"
                  deletable-chips
                  small-chips
                  clearable
                  :error-messages="errors.store_id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </template>

          <template v-if="form.position_id == 3">
            <h2>Driver Details</h2>
            <br />
            <v-row>
              <v-col sm="4">
                <v-text-field
                  v-model="form.driving_license"
                  outlined
                  label="Driving License *"
                  prepend-inner-icon="mdi-card-account-details"
                  :error-messages="errors.driving_license"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-menu
                  v-model="dobMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.dob"
                      label="Date of Birth"
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.dob"
                    @input="dobMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="4">
                <v-menu
                  v-model="doeMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.doe"
                      label="Date of Expiry"
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.doe"
                    @input="doeMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model="form.father_name"
                  outlined
                  label="Father's Name"
                  prepend-inner-icon="mdi-account"
                  :error-messages="errors.father_name"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-autocomplete
                  ref="driverStatus"
                  outlined
                  v-model="form.status"
                  :items="driverStatusItems"
                  label="Status"
                  prepend-inner-icon="mdi-list-status"
                  clearable
                  :error-messages="errors.status"
                ></v-autocomplete>
              </v-col>
              <v-col sm="4">
                <v-switch
                  class="mt-0 ml-5"
                  v-model="form.is_verified"
                  inset
                  :true-value="1"
                  :false-value="0"
                  :label="`Is Verified: ${form.is_verified ? 'YES' : 'NO'}`"
                  @change="console.log('Switch changed to:', form.is_verified)"
                ></v-switch>
              </v-col>
            </v-row>
          </template>

          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            dark
            @click="save"
          >
            Update {{ $route.name == "ProfilePage" ? `Profile` : `User` }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserEditPage",
  data() {
    return {
      form: {
        earned_point: 0,
        given_points: "",
        action_type: 0,
        store_ids: [],
        is_verified: 0,
      },
      isLoading: false,
      clearingImei: false,
      menu: false,
      dobMenu: false,
      doeMenu: false,
      positionItems: [],
      storeItems: [],
      gstItems: [
        {
          id: "Unregistered/Consumer",
          text: "Unregistered/Consumer",
          value: 1,
        },
        { id: "Registered-Regular", text: "Registered-Regular", value: 2 },
        { id: "Registered-Composite", text: "Registered-Composite", value: 3 },
      ],

      statusItems: [
        { text: "Pending", value: 0 },
        { text: "Completed", value: 1 },
        { text: "Reject", value: 2 },
      ],
      driverStatusItems: [
        { text: "Pending", value: 0 },
        { text: "Approved", value: 1 },
        { text: "Rejected", value: 2 },
      ],
      typeItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
      ],
      actionItems: [
        { id: 1, text: "Select Action Type", value: 0 },
        { id: 2, text: "+ Increase", value: 1 },
        { id: 3, text: "- Decrease", value: 2 },
      ],
      isDeleteDeviceDialogs: [],
      isDeleteLocationDialogs: [],
    };
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async clearImei() {
      this.clearingImei = true;
      try {
        await axios.post(`/users/${this.form.id}/clear-imei`);
        this.form.imei_no = null;
        this.$toast.success('Device lock cleared successfully');
      } catch {
        this.$toast.error('Failed to clear device lock');
      } finally {
        this.clearingImei = false;
      }
    },
    async getMasters() {
      await axios
        .get(`users/masters`)
        .then((masters) => {
          masters = masters.data;
          // Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });

          // Stores
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.store_location,
              value: store.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.userId;
      axios
        .get(`/users/${encryptedId}`)
        .then(async (response) => {
          this.form = { ...this.form, ...response.data.data };
          if (this.form.position_id == 5) {
            await this.getStoreData(this.form.id);
          }
          this.old_json = response.data.data;
        })
        .catch((error) => {
          // redirect to Home Page
          // window.location.href = "/auth/login";
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },

    async getStoreData(owner_id) {
      let query = "owner_id=" + owner_id;

      await axios
        .get(`stores?${query}`)
        .then((response) => {
          this.stores = response.data.data;
          this.form.store_ids = this.stores.map((store) => store.id);
        })
        .catch(function (error) {
          console.log(error);
          //window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    // async save() {
    //   try {
    //     this.isLoading = true;
    //     await axios
    //       .post(`/users`, this.form)
    //       .then(async () => {
    //         await this.saveUserTimestamp(this.old_json, this.form);
    //       })
    //       .catch((error) => {
    //         // redirect to Home Page
    //         window.location.href = "/auth/login";
    //         console.error("Error fetching data:", error);
    //       });
    //     this.isLoading = false;
    //     if (this.$route.name == "ProfilePage") {
    //       // this.$router.push("/supervisor");
    //       window.location.href = "/auth/login";
    //     } else {
    //       this.$router.push("/users");
    //     }
    //   } catch (e) {
    //     this.isLoading = false;
    //   }
    // },
    async save() {
      try {
        this.isLoading = true;
        this.form.set_limit =
          this.form.set_limit == 0 ? "" : this.form.set_limit;

        // Debug logging
        console.log("Saving form data:", {
          is_verified: this.form.is_verified,
          old_is_verified: this.old_json?.is_verified,
          position_id: this.form.position_id,
        });

        // Check if is_verified changed from 0 to 1 (false to true)
        const wasVerified = this.old_json && this.old_json.is_verified == 1;
        const isNowVerified = this.form.is_verified == 1;
        const verificationStatusChanged = !wasVerified && isNowVerified;

        await axios.patch(`/users/${this.$route.params.userId}`, this.form);

        // If driver verification status changed to approved, update related raise complaints
        if (verificationStatusChanged && this.form.position_id == 3) {
          await this.updateRelatedRaiseComplaints();
        }

        this.isLoading = false;
        this.$router.push("/users");
      } catch (e) {
        this.isLoading = false;
      }
    },

    async updateRelatedRaiseComplaints() {
      try {
        // Get user ID from the form or old_json
        const userId = this.form.id || this.old_json.id;

        if (userId) {
          await axios.patch(
            `/raise_complaints/approve-by-user/${this.encryptIt(userId)}`,
            {
              status: 1,
              remarks: "Auto-approved due to driver verification",
            }
          );

          this.$toast.success(
            "Related complaints have been automatically approved!",
            {
              position: "top-right",
              timeout: 3000,
            }
          );
        }
      } catch (error) {
        console.error("Error updating related complaints:", error);
        // Don't block the user update if complaint update fails
        this.$toast.warning(
          "User updated but failed to update related complaints",
          {
            position: "top-right",
            timeout: 3000,
          }
        );
      }
    },
  },
};
</script>
